import { useEffect } from 'react'

import classnames from 'classnames'

import Live from 'modules/transmission/components/live'
import useLayout from 'common/hooks/useLayout'
import ConfigMenuMobile from 'modules/transmission/components/configMenuMobile'
import { useChatContext } from 'modules/chat/context'
import { useTransmissionContext } from 'modules/transmission/context'
import useFetchOnFireLanguages from 'modules/transmission/hooks/useFetchOnFireLanguages'
import useSetupChat from 'modules/chat/hooks/useSetupChat'
import { useThemeContext } from 'common/context/theme'
import { useRealtimeDb } from 'modules/firebase/hooks/useRealtimeDb/useRealtimeDb'

/*
TODO: Refatorar e mover funcionalidades do componente modules/transmission/components/live/live.tsx
para esse container
*/
const LiveContainer = () => {
  const { isMobile } = useLayout()
  const { transmissionData } = useTransmissionContext()
  const { isChatVisible } = useChatContext()
  const { darkMode } = useThemeContext()

  const fetchLanguages = useFetchOnFireLanguages()

  useSetupChat()
  useRealtimeDb()

  useEffect(() => {
    fetchLanguages()
  }, [fetchLanguages])

  return (
    <div className={classnames({ 'dark-mode': darkMode })} data-test="live-container">
      <Live
        embedUrl={transmissionData.embedUrl}
        isMobile={isMobile}
        isChatVisible={isChatVisible} />
      <ConfigMenuMobile />
    </div>
  )
}

export default LiveContainer
